import DnsIcon from '@mui/icons-material/Dns';
import { canAccessITWorkspace, isModuleEnabled } from '../../utils/permissions';
import { itRoutes } from './routes';

export const itModule = {
  key: 'it',
  label: 'IT',
  description: 'Workspace operativo per processi, asset e supporto IT.',
  icon: DnsIcon,
  accent: 'success',
  workspacePath: '/it',
  settingsPath: '/settings',
  routes: itRoutes,
  isAvailable: (user) => canAccessITWorkspace(user) && isModuleEnabled(user, 'it'),
  settingsSections: [],
};